// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2Qxed","errorLogs":"EditorFooter_errorLogs__5gYsq"};